let jobs_page = themeVars.jobs_page;
let next_sibling_offer;

document.addEventListener("DOMContentLoaded", (e) => {

	// Open filters on mobile
	const trigger_filters_sm = document.querySelector(".js-trigger-filters-sm");
	if (trigger_filters_sm) {
		trigger_filters_sm.addEventListener("click", (e) => {
			e.currentTarget.parentNode.classList.toggle("filters-open");
		});
	}

	const map = document.querySelector('.jobs-map');

	const search_form = document.getElementById("search-form");
	const tomselects = {};
	if (search_form) {
		const selectors = search_form.querySelectorAll("select");

		selectors.forEach((selector) => {
			let select_id = selector.getAttribute("id");

			if(select_id == 'select-zone' && selector.value != '' && map) {
				let zone_values = Array.from(document.getElementById(select_id).selectedOptions).map(option => option.value);
				if(zone_values.length > 0) {
					zone_values.forEach((zone_value) => {
						let map_slug = document.getElementById(select_id).querySelector('option[value="'+ zone_value +'"]').dataset.slug;
						let map_group = map.querySelector('[data-search="'+ map_slug +'"]');
						if(map_group) {
							map_group.classList.add('active');
						}
					});					
				}				
			}

			const is_mobile = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

			tomselects[select_id] = new TomSelect("#" + select_id, {
				closeAfterSelect: is_mobile,
				maxItems: null, // Allow multiple selections
				controlInput: null,
				plugins: ["change_listener", "remove_button"],
				persist: false,
				create: false,
				onInitialize: function () {
					let placeholderValue = selector.parentNode.dataset.placeholder;

					if (placeholderValue && this.getValue().length == 0) {
						let placeholder = document.createElement("span");
						placeholder.className = "ts-placeholder";
						placeholder.innerText = selector.parentNode.dataset.placeholder;
						this.control.prepend(placeholder);
					}
				},
				render: {
					option: function (data, escape) {
						let pictoHtml = data.picto && data.picto !== "" ? '<span class="picto"><img src="' + escape(data.picto) + '" alt="" /></span>' : "";
						return "<div>" + pictoHtml + '<span class="title">' + escape(data.title) + "</span>" + '<span class="count">' + escape(data.count) + "</span>" + "</div>";
					},
					item: function (data, escape) {
						return '<div class="text-brown"><span>' + escape(data.title) + "</span></div>";
					},
				},
				onChange: function (value) {

					if (this.control.querySelector("span.ts-placeholder")) {
						if (value.length > 0) this.control.querySelector("span.ts-placeholder").classList.add("d-none");
						else this.control.querySelector("span.ts-placeholder").classList.remove("d-none");
					} else if(value == '') {
						let placeholderValue = selector.parentNode.dataset.placeholder;

						if (placeholderValue) {
							let placeholder = document.createElement("span");
							placeholder.className = "ts-placeholder";
							placeholder.innerText = selector.parentNode.dataset.placeholder;
							this.control.prepend(placeholder);
						}
					}

					if(select_id == 'select-zone' && map) {
						map.querySelectorAll('g').forEach((group) => {
							group.classList.remove('active');
						});

						if(value.length > 0) {
							value.forEach((val) => {
								let map_slug = document.getElementById(select_id).querySelector('option[value="'+ val +'"]').dataset.slug;
								let map_group = map.querySelector('[data-search="'+ map_slug +'"]');
								if(map_group) {
									map_group.classList.add('active');
								}
							});
						}
					}
					
					if(is_mobile) trigger_filters_sm.click();

					jQuery.ajax({
						url: themeVars.ajaxUrl,
						type: "POST",
						data: {
							action: "ujpm",
							function: "get_jobs",
							data: jQuery(search_form).serialize(),
						},
						beforeSend: function () {

							let domain_url = [];
							let values = tomselects['select-domaine'].getValue();
							values.forEach((value) => {
								domain_url.push(document.getElementById("select-domaine").querySelector('option[value="' + value + '"]').dataset.slug);
							});
							domain_url = (domain_url.length > 0 ? domain_url.join("_") : 'all');
							
							let zone_url = [];
							values = tomselects['select-zone'].getValue();
							values.forEach((value) => {
								zone_url.push(document.getElementById("select-zone").querySelector('option[value="' + value + '"]').dataset.slug);
							});
							zone_url = (zone_url.length > 0 ? zone_url.join("_") : 'all');

							history.pushState({}, "", themeVars.jobs_page + domain_url + "/" + (zone_url != "" ? zone_url + "/" : ""));

							document.querySelector(".job-loader").classList.add("is-visible");
						},
						success: function (response) {
							document.querySelector(".job-loader").classList.remove("is-visible");
							if (response.success) {
								document.querySelector(".jobs-count").innerHTML = response.data.count;
								document.querySelector(".jobs-listing").innerHTML = response.data.html;
								document.querySelector(".jobs-pagination").innerHTML = response.data.pagination;
								document.querySelector("h1").innerHTML = response.data.h1;
								// Smooth scroll to results (jobs-listing)
								const element = document.querySelector(".jobs-listing");
								const header = document.querySelector(".header");
								if(element && header) {
									let topPos = element.offsetTop - header.offsetHeight - 2 * header.offsetTop;
									window.scrollTo({
										top: topPos,
										behavior: "smooth"
									});
								}
							}
						},
					});
	
				}

			});
		});

		const reset = search_form.querySelector('button[type="reset"]');
		if (reset) {
			reset.addEventListener("click", () => {
				Object.entries(tomselects).forEach(([key, instance]) => {
					instance.clear();
				});
			});
		}
	}

	// localize on map 
	if(map) {
		let selectZone = tomselects['select-zone'];
		let groups = map.querySelectorAll('g');
		groups.forEach((group) => {
			group.addEventListener('click', () => {
				let select_slug = group.dataset.search;
				let value = document.getElementById('select-zone').querySelector('[data-slug="'+ select_slug +'"]').value;
				if (!group.classList.contains('active')) {
					group.classList.add('active');
					selectZone.addItem(value);
				} else {
					group.classList.remove('active');
					selectZone.removeItem(value);
				}

				let header = document.querySelector(".header");
				let element = document.querySelector(".jobs-listing");
				if(element && header) {
					let topPos = element.offsetTop - header.offsetHeight - 2 * header.offsetTop;

					window.scrollTo({
						top: topPos,
						behavior: "smooth"
					});
				}
			})
		});
	}

	const display_map = document.querySelector('.click-map-js');
	const display_list = document.querySelector('.click-list-js');
	if(display_map && display_list) {
		display_map.addEventListener('click', (e) => {
			display_map.classList.add('d-none');
			display_list.classList.remove('d-none');
			map.classList.remove('d-none');
		});
		display_list.addEventListener('click', (e) => {
			display_list.classList.add('d-none');
			display_map.classList.remove('d-none');
			map.classList.add('d-none');
		});
	}

});

function next_offer(e) {
	if (e.target.matches(".job-detail_actions_next")) {
		next_sibling_offer.querySelector(".job-card__actions > a").click();
	}
}

document.addEventListener("click", (e) => {
	// close job detail panel
	const clickedOutsidePanel = !e.target.closest(".job-details-panel");
	const clickedCloseButton = e.target.classList.contains("job-detail_actions_close");
	if (document.querySelector(".job-detail").classList.contains("shown") && (clickedOutsidePanel || clickedCloseButton)) {
		document.querySelector(".job-detail").classList.remove("shown");

		history.pushState({}, "", jobs_page);

		setTimeout(() => {
			document.body.style.overflowY = "auto";
		}, 500);
	}

	// open job detail panel
	if (e.target.closest(".job-card__actions")) {
		e.preventDefault();

		document.querySelector(".job-loader").classList.add("is-visible");

		jQuery.ajax({
			url: themeVars.ajaxUrl,
			type: "POST",
			data: {
				action: "ujpm",
				function: "get_job_detail",
				data: e.target.dataset.jobId,
			},
			success: function (response) {
				document.querySelector(".job-loader").classList.remove("is-visible");
				if (response.success) {
					document.querySelector(".job-detail").innerHTML = response.data.html;
					initMap();

					next_sibling_offer = document.querySelector('.jobs-listing [data-job="job-' + e.target.dataset.jobId + '"]').nextElementSibling;

					document.removeEventListener("click", next_offer);
					if (next_sibling_offer != null) {
						document.querySelectorAll(".job-detail_actions_next").forEach((next_button) => {
							next_button.classList.remove("d-none");
						});
						document.addEventListener("click", next_offer);
					}

					document.querySelector(".job-detail").classList.add("shown");
					document.body.style.overflowY = "hidden";
				}
			},
		});

		let paged = window.location.href.replace(themeVars.jobs_page, "");
		if (paged != "") {
			jobs_page = themeVars.jobs_page + paged;
		}

		history.pushState({ job_id: e.target.dataset.jobId }, "", e.target.href);
	}

	// pagination arrows
	if (e.target.closest(".jobs-pagination") && e.target.closest(".arrow")) {
		const search_form = document.getElementById("search-form");
		let page = e.target.closest(".arrow").dataset.page;

		jQuery.ajax({
			url: themeVars.ajaxUrl,
			type: "POST",
			data: {
				action: "ujpm",
				function: "get_jobs",
				data: jQuery(search_form).serialize() + "&page=" + page,
			},
			beforeSend: function () {
				window.scrollTo({
					top: document.querySelector(".job-loader").parentElement.offsetTop - document.querySelector(".header").offsetHeight,
					left: 0,
					behavior: "smooth",
				});
				document.querySelector(".job-loader").classList.add("is-visible");
			},
			success: function (response) {
				document.querySelector(".job-loader").classList.remove("is-visible");
				if (response.success) {
					document.querySelector(".jobs-count").innerHTML = response.data.count;
					document.querySelector(".jobs-listing").innerHTML = response.data.html;
					document.querySelector(".jobs-pagination").innerHTML = response.data.pagination;

					let domain_url = document.getElementById("select-domaine").value != "" ? document.getElementById("select-domaine").querySelector('option[value="' + document.getElementById("select-domaine").value + '"]').dataset.slug : "all";
					let zone_url = document.getElementById("select-zone").value != "" ? document.getElementById("select-zone").querySelector('option[value="' + document.getElementById("select-zone").value + '"]').dataset.slug : "all";

					history.pushState({}, "", themeVars.jobs_page + domain_url + "/" + (zone_url != "" ? zone_url + "/" : "") + page + "/");
				}
			},
		});
	}
});
